var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInflation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.79878 16.402C12.9786 16.402 16.3671 13.0135 16.3671 8.83369C16.3671 4.65383 12.9786 1.26538 8.79878 1.26538C4.61892 1.26538 1.23047 4.65383 1.23047 8.83369C1.23047 13.0135 4.61892 16.402 8.79878 16.402Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3475 5.72636H8.2601C8.05572 5.72494 7.85307 5.76397 7.66384 5.8412C7.47461 5.91843 7.30253 6.03233 7.15751 6.17635C7.01249 6.32038 6.8974 6.49166 6.81886 6.68036C6.74032 6.86905 6.69989 7.07141 6.69989 7.2758C6.70273 7.68772 6.86836 8.0818 7.16065 8.37208C7.45294 8.66235 7.84816 8.82525 8.2601 8.82524H9.3361C9.74803 8.82523 10.1432 8.98813 10.4355 9.2784C10.7278 9.56867 10.8935 9.96275 10.8963 10.3747C10.9052 10.5886 10.8701 10.8021 10.7929 11.0018C10.7158 11.2016 10.5984 11.3833 10.448 11.5357C10.2976 11.6881 10.1175 11.808 9.91878 11.8877C9.72008 11.9675 9.50708 12.0055 9.29306 11.9994H7.03346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79614 5.6865V4.52441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79614 13.2189V12.1106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1998 10.7344L16.5631 20.2407C16.376 20.4253 16.1237 20.5288 15.8608 20.5288H9.65815C9.44703 20.5288 9.24132 20.5956 9.07049 20.7197L1.80078 25.9997",
    strokeMiterlimit: 10,
    fill: "none",
    "data-nofill": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.2504L26.7784 10.2314L26.7974 16",
    fill: "none",
    "data-nofill": "true"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflation);
export default __webpack_public_path__ + "static/media/inflation.845b30536e6bead7018aee7205b54f57.svg";
export { ForwardRef as ReactComponent };